let readingTimes: Record<string, string> = {};

export const loadReadingTimes = async () => {
  try {
    const response = await fetch('/assets/json/reading-times.json');

    readingTimes = await response.json();
  } catch (error) {
    console.error(error);
    readingTimes = {};
  }
};

export const getReadingTime = (
    id: string | number
  ): string | null => {

    return readingTimes[String(id)] ?? null;
  };